import store from 'store';
import { getConfig } from 'core/helpers';

import { STORAGE_THEME_COLOR, THEME_MODE } from '../constants';

export const setColorTheme = theme => theme && store.set(STORAGE_THEME_COLOR, theme);
// Change condition's last value (THEME_MODE.LIGHT) to 'dark' if needed
export const getColorTheme = () => store.get(STORAGE_THEME_COLOR) || getConfig('DEFAULT_THEME') || THEME_MODE.DARK;
